(() => {
  if (window.lookbookHotspotPreviewBound) return;
  window.lookbookHotspotPreviewBound = true;

  const executeScripts = (root) => {
    root.querySelectorAll('script').forEach((oldScript) => {
      const newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value));
      newScript.appendChild(document.createTextNode(oldScript.innerHTML));
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  };

  const ensureFallback = () => {
    let shell = document.querySelector('#LookbookMiniPdpFallback');
    if (shell) return shell;

    shell = document.createElement('div');
    shell.id = 'LookbookMiniPdpFallback';
    shell.hidden = true;
    shell.innerHTML = `
      <div data-lookbook-mini-pdp-backdrop></div>
      <div data-lookbook-mini-pdp-panel>
        <button type="button" data-lookbook-mini-pdp-close aria-label="Fechar">×</button>
        <div data-lookbook-mini-pdp-content></div>
      </div>
    `;

    const style = document.createElement('style');
    style.textContent = `
      #LookbookMiniPdpFallback[hidden]{display:none!important}
      #LookbookMiniPdpFallback{position:fixed;inset:0;z-index:9999;display:flex;justify-content:flex-end}
      #LookbookMiniPdpFallback [data-lookbook-mini-pdp-backdrop]{position:absolute;inset:0;background:rgba(0,0,0,.28)}
      #LookbookMiniPdpFallback [data-lookbook-mini-pdp-panel]{position:relative;z-index:1;width:min(48rem,100vw);height:100%;background:#fff;overflow:auto;box-shadow:-1rem 0 3rem rgba(0,0,0,.12)}
      #LookbookMiniPdpFallback [data-lookbook-mini-pdp-close]{position:absolute;top:1.2rem;right:1.2rem;z-index:3;width:4rem;height:4rem;border:0;background:#fff;font-size:2.8rem;line-height:1;cursor:pointer}
      #LookbookMiniPdpFallback [data-lookbook-mini-pdp-content]{min-height:100%}
      @media(max-width:989px){
        #LookbookMiniPdpFallback{align-items:flex-end}
        #LookbookMiniPdpFallback [data-lookbook-mini-pdp-panel]{width:100%;height:min(86svh,80rem);border-radius:1.6rem 1.6rem 0 0}
      }
    `;
    document.head.appendChild(style);
    document.body.appendChild(shell);

    const close = () => {
      shell.hidden = true;
      shell.querySelector('[data-lookbook-mini-pdp-content]').innerHTML = '';
      document.documentElement.style.overflow = '';
    };
    shell.querySelector('[data-lookbook-mini-pdp-close]').addEventListener('click', close);
    shell.querySelector('[data-lookbook-mini-pdp-backdrop]').addEventListener('click', close);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !shell.hidden) close();
    });

    return shell;
  };

  const openFallback = async (url) => {
    const shell = ensureFallback();
    const content = shell.querySelector('[data-lookbook-mini-pdp-content]');
    content.innerHTML = '';
    shell.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', 'mini-pdp');

    try {
      const res = await fetch(fetchUrl.toString());
      if (!res.ok) throw new Error('Falha ao carregar o Mini PDP');
      content.innerHTML = await res.text();
      executeScripts(content);
    } catch (error) {
      console.error('[Lookbook] Mini PDP fallback failed:', error);
      shell.hidden = true;
      document.documentElement.style.overflow = '';
      window.location.assign(url);
    }
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-lookbook-hotspot-button]');
    if (!button) return;

    const url = button.dataset.miniPdpTrigger;
    if (!url) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const nativeModal = document.querySelector('#CartDrawerMiniPdp');
    const manager = window.CartDrawerManager;

    if (nativeModal && manager?.openMiniPdp) {
      try {
        await manager.openMiniPdp(url, button);
        return;
      } catch (error) {
        console.warn('[Lookbook] Native Mini PDP failed, using fallback.', error);
      }
    }

    await openFallback(url);
  }, true);
})();